import React, { useCallback, useMemo } from 'react';

import { Box } from '@mui/material';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useRegisterPageRefreshHandler } from '../../../../components/layout/page-container/page-refresh-handler';
import CommunitiesListBig from '../../../../components/reusable/communities-list/CommunitiesListBig';
import { CommunitiesListRefreshProvider } from '../../../../components/reusable/communities-list/CommunitiesListRefreshContext';
import { useGetMyCommunities } from '../../../../redux/api/communitiesApi';

export default function MyCommunities() {
  const {
    data: myCommunities,
    refetch,
    isFetching,
    isError,
    error,
  } = useGetMyCommunities();
  const pageDataOwners = useMemo(
    () => ({
      myCommunities: myCommunities ?? null,
    }),
    [myCommunities],
  );
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageRefreshHandler(() => void refetch());
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading:
      Boolean(isFetching) && pageDataOwners.myCommunities === undefined,
    hasData: Boolean(pageDataOwners.myCommunities?.length),
    onRetry: handleRetry,
  });

  return (
    <Box>
      <CommunitiesListRefreshProvider refetch={() => void refetch()}>
        <CommunitiesListBig
          communities={pageDataOwners.myCommunities}
          showSearch
          isLoading={
            Boolean(isFetching) && pageDataOwners.myCommunities === undefined
          }
          isError={isError}
        />
      </CommunitiesListRefreshProvider>
    </Box>
  );
}
